{
    "ReportingMenu_FirstClosePopup": "Pour rouvrir le menu, cliquez sur le bouton « Rapports » dans la barre latérale lorsque vous êtes sur la page Rapports.",
    "NAME": "ReportingMenuLanguage"
}